import script from "./RankingWorldPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RankingWorldPage.vue?vue&type=script&setup=true&lang=js"

import "./RankingWorldPage.vue?vue&type=style&index=0&id=0df7518a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df7518a"]])

export default __exports__